import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

export const detailInfoPanelSurfaceSx: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  '& .flowqa-info-field': {
    gap: s('sm'),
  },
  '& .flowqa-info-field + .flowqa-info-field': {
    marginTop: s('md'),
  },
  '& .flowqa-info-field-label': {
    fontSize: '13px',
    lineHeight: 1.4,
  },
  '& .flowqa-info-field-value': {
    fontSize: '15px',
    lineHeight: 1.4,
  },
};
